"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPodcastComponent = void 0;
var React = require("react");
var app_1 = require("app");
var webexUI_1 = require("webexUI");
var components_1 = require("./components");
var PodcastPlayer = function (_a) {
    var podcast = _a.podcast, orderOnPage = _a.orderOnPage;
    var audioRef = React.useRef(null);
    var _b = React.useState(false), isPlaying = _b[0], setIsPlaying = _b[1];
    var _c = React.useState(false), isEnded = _c[0], setIsEnded = _c[1];
    var _d = React.useState(0), currentTime = _d[0], setCurrentTime = _d[1];
    var _e = React.useState(0), duration = _e[0], setDuration = _e[1];
    var _f = React.useState(function () { return (0, webexUI_1.detectBreakpoint)(webexUI_1.Breakpoint.Tablet); }), isMobile = _f[0], setIsMobile = _f[1];
    var updateSize = (0, webexUI_1.throttle)(function () { return setIsMobile((0, webexUI_1.detectBreakpoint)(webexUI_1.Breakpoint.Tablet)); }, 100);
    React.useLayoutEffect(function () {
        window.addEventListener('resize', updateSize);
        return function () { return window.removeEventListener('resize', updateSize); };
    }, [updateSize]);
    React.useEffect(function () {
        var audio = audioRef.current;
        if (audio) {
            var handlePlay_1 = function () { return setIsPlaying(true); };
            var handlePause_1 = function () { return setIsPlaying(false); };
            audio.addEventListener('play', handlePlay_1);
            audio.addEventListener('pause', handlePause_1);
            return function () {
                audio.removeEventListener('play', handlePlay_1);
                audio.removeEventListener('pause', handlePause_1);
            };
        }
    }, []);
    var pauseAllPlayers = React.useCallback(function (event) {
        var audio = audioRef.current;
        if (!audio)
            return;
        if (event.detail.playedPlayerOrder === orderOnPage) {
            audio.play();
        }
        else {
            audio.pause();
        }
    }, [orderOnPage]);
    React.useEffect(function () {
        window.addEventListener('pausePlayer', pauseAllPlayers);
        return function () {
            window.removeEventListener('pausePlayer', pauseAllPlayers);
        };
    }, [pauseAllPlayers]);
    var handleTimeUpdate = React.useCallback(function () {
        if (audioRef.current) {
            setCurrentTime(audioRef.current.currentTime);
        }
    }, []);
    var handleLoadedMetadata = React.useCallback(function () {
        if (audioRef.current) {
            setDuration(audioRef.current.duration);
        }
    }, []);
    var handleAudioEnded = React.useCallback(function () {
        if (audioRef.current) {
            setCurrentTime(0);
            setIsEnded(true);
        }
    }, []);
    return (React.createElement("div", { className: "podcast-player flex-center p-4 bg-surface-tertiary rounded-lg shadow-lg tablet:flex-wrap" },
        React.createElement(components_1.PodcastPlayerPlayButton, { isPlaying: isPlaying, audioRef: audioRef, orderOnPage: orderOnPage, isEnded: isEnded, setIsEnded: setIsEnded }),
        React.createElement(components_1.PodcastPlayerInfo, { title: podcast.title, link: podcast.link, audioRef: audioRef, isPlaying: isPlaying, currentTime: currentTime, duration: duration, setCurrentTime: setCurrentTime, isMobile: isMobile }),
        React.createElement(components_1.PodcastPlayerControllers, { podcastLink: podcast.podcastLink, audioRef: audioRef, isMobile: isMobile }),
        React.createElement("audio", { crossOrigin: "anonymous", ref: audioRef, src: podcast.src, onEnded: handleAudioEnded, onTimeUpdate: handleTimeUpdate, onLoadedMetadata: handleLoadedMetadata })));
};
function renderPodcastComponent(element, podcast, orderOnPage) {
    (0, app_1.reactDOMRender)(React.createElement(PodcastPlayer, { podcast: podcast, orderOnPage: orderOnPage }), element);
}
exports.renderPodcastComponent = renderPodcastComponent;
